import { _integratedAxios } from "@/plugins/integragedAxios";

const getSugangInfo = (code) => {
  return _integratedAxios.get(`/user/sugang/${code}`);
};

const authMobile = (params) => {
  return _integratedAxios.post(
    `/user/auth/mobile?countryCode=${params.countryCode}&mobile=${params.mobile}&userName=${params.userName}`
  );
};

const authEmail = (params) => {
  return _integratedAxios.post(
    `/user/auth/email?email=${params.email}&userName=${params.userName}`
  );
};

const authMobileCheck = (params) => {
  return _integratedAxios.get(
    `/user/auth/mobile/check?authNumber=${params.authNumber}&countryCode=${params.countryCode}&mobile=${params.mobile}&userName=${params.userName}`
  );
};

const authEmailCheck = (params) => {
  return _integratedAxios.get(
    `/user/auth/email/check?authNumber=${params.authNumber}&email=${params.email}&userName=${params.userName}`
  );
};

const noticeList = (code, params) => {
  return _integratedAxios.get(`/user/sugang/${code}/board/notice/list`, {
    params,
  });
};

const getEmail = (code, params) => {
  return _integratedAxios.get(`/user/auth/${code}/email`, { params });
};

const noticeDetail = (code, boardIdx) => {
  return _integratedAxios.get(`/user/sugang/${code}/board/notice/${boardIdx}`);
};

const faqActiveList = (code) => {
  return _integratedAxios.get(`/user/sugang/${code}/faq/active-list`);
};

const faqCategoryList = (faqCategoryIdx, params) => {
  return _integratedAxios.get(`/user/sugang/faq/${faqCategoryIdx}/list`, {
    params,
  });
};

const sugangCompletion = (code, courseIdx) => {
  return _integratedAxios.get(
    `/user/sugang/${code}/course/${courseIdx}/completion`
  );
};

const sugangRoadMap = (code, courseIdx) => {
  return _integratedAxios.get(
    `/user/sugang/${code}/course/${courseIdx}/roadmap`
  );
};

//수강신청 데이터 저장
const saveSugangInfo = (params) => {
  return _integratedAxios.post(
    `/user/sugang/${params.code}/course/${params.courseIdx}/apply?email=${params.email}&mobile=${params.mobile}`
  );
};

//수강신청 데이터 삭제
const deleteSugangInfo = (params) => {
  return _integratedAxios.post(
    `/user/sugang/${params.code}/course/${params.courseIdx}/apply/cancel?email=${params.email}&mobile=${params.mobile}`
  );
};

//수강신청 중복상태 확인
const dupSugangInfo = (params) => {
  return _integratedAxios.get(
    `/user/sugang/${params.code}/course/apply/check?courseIdx=${params.courseIdx}&email=${params.email}&mobile=${params.mobile}`
  );
};
//CTM 언어 리스트
const getLanguageInfo = () => {
  return _integratedAxios.get(`/user/ctm/tutor/language/list`);
};
//ITM 언어 리스트
const getLanguageInfoG = () => {
  return _integratedAxios.get(`/user/itm/tutor/language/list`);
};
//CTM 강사 리스트
const getTutorListInfo = (params) => {
  return _integratedAxios.get(
    `/user/ctm/tutor/list?languageIdx=${params.idx}&pageNum=${params.pagingNum}&pageSize=30`
  );
};
//ITM 강사 리스트
const getTutorListInfoG = (params) => {
  return _integratedAxios.get(
    `/user/itm/tutor/list?languageIdx=${params.idx}&pageNum=${params.pagingNum}&pageSize=30`
  );
};

//CTM 강사 리스트 검색할때 호출
const getTutorInfo = (params) => {
  return _integratedAxios.get(
    `/user/ctm/tutor/list?languageIdx=${params.idx}&name=${params.name}&pageNum=1&pageSize=30`
  );
};
//ITM 강사 리스트 검색할때 호출
const getTutorInfoG = (params) => {
  return _integratedAxios.get(
    `/user/itm/tutor/list?languageIdx=${params.idx}&name=${params.name}&pageNum=1&pageSize=30`
  );
};
// CTM 강사 프로필
const getTutorDetailInfo = (params) => {
  return _integratedAxios.get(`/user/ctm/tutor/${params.idx}`);
};
// ITM 강사 프로필
const getTutorDetailInfoG = (params) => {
  return _integratedAxios.get(`/user/itm/tutor/${params.idx}`);
};
// CTM 강사 후기
const getTutorDetailGrade = (params) => {
  return _integratedAxios.get(`/user/ctm/tutor/${params.idx}/review`);
};
// ITM 강사 후기
const getTutorDetailGradeG = (params) => {
  return _integratedAxios.get(`/user/itm/tutor/${params.idx}/review`);
};

//대리인 등록
const registerProxy = (params) => {
  return _integratedAxios.post(`/user/sugang/proxy`, params);
};

//대리인 리스트 조회
const getProxyList = (params) => {
  return _integratedAxios.get(`/user/sugang/proxy/list`, { params });
};

export {
  getSugangInfo,
  registerProxy,
  authMobile,
  authEmail,
  authMobileCheck,
  authEmailCheck,
  noticeList,
  noticeDetail,
  faqActiveList,
  faqCategoryList,
  sugangCompletion,
  sugangRoadMap,
  saveSugangInfo,
  deleteSugangInfo,
  dupSugangInfo,
  getLanguageInfo,
  getTutorListInfo,
  getTutorInfo,
  getTutorDetailInfo,
  getTutorDetailGrade,
  getLanguageInfoG,
  getTutorListInfoG,
  getTutorInfoG,
  getTutorDetailInfoG,
  getTutorDetailGradeG,
  getEmail,
  getProxyList,
};
